<template>
  <v-row class="document-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12" v-if="isDownloadError" ref="downloadError">
          <v-alert
            dense
            text
            type="error"
            icon="mdi-alert-circle"
            class="ma-0 flex-grow-1 rounded-lg"
          >
            <span class="black--text">
              <strong>Sorry! </strong> Document could not be downloaded at this
              time.
            </span>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <h2>Policy documents</h2>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          v-for="(document, index) in policyDocumentList"
          :key="index"
        >
          <div class="document__item document__item--spacing">
            <h3>
              {{ document?.title }}
              <v-icon color="white" class="mr-2">mdi-file</v-icon>
            </h3>
            <h4>{{ document?.subtitle }}</h4>
            <p class="font-14">
              {{ document?.description }}
            </p>
            <div>
              <BaseButton
                :ripple="false"
                @click="downloadFile(document)"
                depressed
                rounded
                color="mustard"
                x-large
                className="font-weight-bold font-18 text-uppercase mx-auto"
                download
                :loading="document?.isDownloading"
                text="DOWNLOAD"
                loadingText="DOWNLOADING..."
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { downloadDocument } from "@/common/utils";
import { POLICY_DOCUMENT } from "@/constants/d2c-landing-page.constants";
import documentService from "@/services/document.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";
import BaseButton from "../BaseComponents/BaseButton.vue";

export default {
  name: "LandingPagePolicyDocument",
  components: {
    BaseButton,
  },
  data() {
    return {
      isDownloadError: false,
    };
  },
  props: {
    policyDocumentList: {
      type: Array,
      default: () => POLICY_DOCUMENT,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["httpConfig"]),
  },
  methods: {
    async downloadFile(file) {
      this.isDownloadError = false;
      file.isDownloading = true;
      try {
        const doc = await documentService.getDocument(
          file.Link,
          this.httpConfig
        );
        downloadDocument(doc, file.fileName);
        file.isDownloading = false;
      } catch (e) {
        this.isDownloadError = true;
        setTimeout(() => {
          const el = this.$refs.downloadError;
          var yourHeight = 80; //heigh of float header panel
          // scroll to your element
          if (el) {
            el.scrollIntoView(true);
          }
          // now account for fixed header
          var scrolledY = window.scrollY;
          if (scrolledY) {
            window.scroll(0, scrolledY - yourHeight);
          }
        }, 500);
        console.error(e);
        file.isDownloading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.document-wrapper {
  background: #fff;
  padding: 33px 0 64px 0;
  .col-lg-6 {
    .document__item {
      margin-left: auto;
    }
    &:last-child {
      .document__item {
        margin-left: 0;
        margin-right: auto;
      }
    }
  }
  .document__item {
    padding: 35px 36px 94px 36px;
    border-radius: 10px;
    background: #354048;
    color: #fff;
    border-radius: 10px;
    max-width: 440px;
    height: 100%;
    min-height: 320px;
    margin: 0 22px;
    position: relative;
    p {
      padding: 32px 0 34px;
      font-size: 14px;
    }
    h4 {
      font-size: 14px;
      margin-top: -5px;
      font-weight: 600;
    }
    h3 {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 10px;
      .mdi-file {
        font-size: 35px;
      }
    }
    .v-btn {
      width: calc(100% - 72px);
      min-width: auto;
      height: 54px;
      margin-top: 0;
      font-size: 20px !important;
      position: absolute;
      bottom: 40px;
    }
  }
}
@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .document-wrapper {
    padding: 4px 0 20px 0;
    .app-container--width-max {
      padding: 0 !important;
    }
    .document__item {
      margin: 0 !important;
      .v-btn {
        width: auto;
        min-width: calc(100% - 72px);
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .policy-document__container {
    grid-template-columns: auto;
  }
}
</style>
